webpackJsonp([35783957827783],{

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  border-radius: 8px;\n  margin: 0 0 1em 0;\n  width: 100%;\n  transition: background .2s;\n  @media screen and (min-width: ', ') {\n    flex: 0 0 49%;\n    margin: 0 0 2vw 0;\n  }\n  @media screen and (min-width: ', ') {\n    flex: 0 0 32%;\n  }\n  a {\n    overflow: hidden;\n    display: flex;\n    flex-flow: column;\n    height: 100%;\n    width: 100%;\n    color: ', ';\n    text-decoration: none;\n    transition-property: color, background-color, background-size, box-shadow, transform;\n    transition-duration: 0.15s;\n    box-shadow: rgba(0, 0, 0, 0.3) 0px 2px 4px 0px;\n    border-radius: 8px;\n      div {\n        height: 0;\n        padding-bottom: 60%;\n      }\n  }\n  a:hover {\n    box-shadow: rgba(0, 0, 0, 0.3) 0px 4px 8px 0px;\n  }\n'], ['\n  border-radius: 8px;\n  margin: 0 0 1em 0;\n  width: 100%;\n  transition: background .2s;\n  @media screen and (min-width: ', ') {\n    flex: 0 0 49%;\n    margin: 0 0 2vw 0;\n  }\n  @media screen and (min-width: ', ') {\n    flex: 0 0 32%;\n  }\n  a {\n    overflow: hidden;\n    display: flex;\n    flex-flow: column;\n    height: 100%;\n    width: 100%;\n    color: ', ';\n    text-decoration: none;\n    transition-property: color, background-color, background-size, box-shadow, transform;\n    transition-duration: 0.15s;\n    box-shadow: rgba(0, 0, 0, 0.3) 0px 2px 4px 0px;\n    border-radius: 8px;\n      div {\n        height: 0;\n        padding-bottom: 60%;\n      }\n  }\n  a:hover {\n    box-shadow: rgba(0, 0, 0, 0.3) 0px 4px 8px 0px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  font-size: 1.5em;\n  font-weight: 600;\n  margin: 1rem 1rem .5rem 1rem;\n'], ['\n  font-size: 1.5em;\n  font-weight: 600;\n  margin: 1rem 1rem .5rem 1rem;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  margin: 0 1rem 1.5rem 1rem;\n  color: gray;\n'], ['\n  margin: 0 1rem 1.5rem 1rem;\n  color: gray;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  margin: 0 1rem 1rem 1rem;\n  line-height: 1.6;\n'], ['\n  margin: 0 1rem 1rem 1rem;\n  line-height: 1.6;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(57);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(109);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Post = _styledComponents2.default.li(_templateObject, function (props) {
	  return props.theme.responsive.small;
	}, function (props) {
	  return props.theme.responsive.medium;
	}, function (props) {
	  return props.theme.colors.base;
	});
	
	var Title = _styledComponents2.default.h2(_templateObject2);
	
	var Date = _styledComponents2.default.h3(_templateObject3);
	
	var Excerpt = _styledComponents2.default.p(_templateObject4);
	
	var Card = function Card(props) {
	  return _react2.default.createElement(
	    Post,
	    null,
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/' + props.slug + '/' },
	      _react2.default.createElement(_gatsbyImage2.default, { sizes: props.image.sizes, backgroundColor: '#eeeeee' }),
	      _react2.default.createElement(
	        Title,
	        null,
	        props.title
	      ),
	      _react2.default.createElement(
	        Date,
	        null,
	        props.date
	      ),
	      _react2.default.createElement(Excerpt, { dangerouslySetInnerHTML: { __html: props.excerpt.childMarkdownRemark.excerpt } })
	    )
	  );
	};
	
	exports.default = Card;
	module.exports = exports['default'];

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  margin: 0 auto;\n  &::after {\n    content: "";\n    flex: 0 0 32%;\n  }\n'], ['\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  margin: 0 auto;\n  &::after {\n    content: "";\n    flex: 0 0 32%;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var List = _styledComponents2.default.ul(_templateObject);
	
	var CardList = function CardList(props) {
	  return _react2.default.createElement(
	    List,
	    null,
	    props.children
	  );
	};
	
	exports.default = CardList;
	module.exports = exports['default'];

/***/ }),

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(44);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _siteConfig = __webpack_require__(46);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _CardList = __webpack_require__(124);
	
	var _CardList2 = _interopRequireDefault(_CardList);
	
	var _Card = __webpack_require__(123);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Container = __webpack_require__(68);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _PageTitle = __webpack_require__(96);
	
	var _PageTitle2 = _interopRequireDefault(_PageTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Index = function Index(_ref) {
	  var data = _ref.data;
	
	
	  var posts = data.allContentfulPost.edges;
	
	  return _react2.default.createElement(
	    _Container2.default,
	    null,
	    _react2.default.createElement(
	      _PageTitle2.default,
	      null,
	      'Diana Golay'
	    ),
	    _react2.default.createElement(
	      _CardList2.default,
	      null,
	      posts.map(function (_ref2) {
	        var post = _ref2.node;
	        return _react2.default.createElement(_Card2.default, {
	          key: post.id,
	          slug: post.slug,
	          image: post.heroImage,
	          title: post.title,
	          date: post.publishDate,
	          excerpt: post.body
	        });
	      })
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = Index;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-6a6e0af75703040499e4.js